<template>
	<div class="tab-body">
		<div class="search">
			<el-form ref="form" :model="searchParams" label-width="80px">
				<el-row>
					<el-col :span="6">
						<el-form-item label="科 目">
							<el-input placeholder="请选择科目" disabled v-model="searchParams.sbname">
								<template slot="append">
									<el-button type="primary" @click="selectSub()">选择</el-button>
								</template>
							</el-input>
							<el-input v-model="searchParams.sbid" v-show="false"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<div class="search-btn">
							<!-- <el-button type="primary" size="mini"   @click="search">搜索</el-button>
							<el-button type="success"   size="mini" @click="searchCount">统计</el-button> -->
							<el-button @click="clearSearchVal">清空</el-button>
						</div>
					</el-col>
				</el-row>
			</el-form>
		</div>
        <div class="dataTable autoFlex" v-if="listData">
			<el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange" v-loading="listLoading">
						<el-table-column  width="300"  prop="sbname" label="科目名称"></el-table-column>
						<el-table-column    prop="qnm" label="试题名称"></el-table-column>
						<el-table-column  width="90" prop="cnt" label="题次"></el-table-column>
						<el-table-column  width="90" prop="rrate" label="得分率"></el-table-column>
						<el-table-column  width="110"  prop="type" label="试题类型"></el-table-column>
						<el-table-column width="130" prop="exmtm" label="最后做题时间"></el-table-column>
				<el-table-column label="操作" fixed="right" width="200px">
					<template slot-scope="scope">
						<div class="dataTable-operator">
							<el-button v-has-permission-code-and="'0040002000400005'" size="mini" icon="el-icon-search" @click="toDetail(scope.$index, scope.row)">详情</el-button>
						    <!-- <el-button v-has-permission-code-and="''" size="mini" icon="el-icon-edit" @click="toUpdate(scope.$index, scope.row)">编辑</el-button>
                            <el-button v-has-permission-code-and="''" size="mini" icon="el-icon-delete" type="danger" @click="remove(scope.$index, scope.row)">删除</el-button> -->
                        </div>
					</template>
				</el-table-column>
			</el-table>
			<el-dialog title="选择科目" :visible.sync="dialogVisible" width="60%" :append-to-body="true">
				<tree class="filter-tree" ref="permissionTree" check-strictly :items="permissionList"
					:data="permissionList" :defaultParent="0" @nodeClick="treeClick" :expand-on-click-node="true">
				</tree>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="comfirmSub">确 定</el-button>
				</span>
			</el-dialog>
			<div class="pageBar">
				<el-pagination 
				@size-change="sizeChange" 
				@current-change="currentChange" 
				:total="listData.total" 
				:page-size="page.size"
				:current-page="page.current" 
				:layout="this.$constant.page.layout" 
				:page-sizes="this.$constant.page.pageSizes"></el-pagination>
			</div>
		</div>
		<edit ref="edit"></edit>
	</div>
</template>
<script>
import { table } from 'console';
import edit from './edit.vue';
import api from '@/api/exams/exams/rpt_answers.js';
import subApi from "@/api/edu/subject/subject.js";
import tree from "@/components/tree/tree.vue";
export default {
	name: 'rptAnswers',
	components: {
		edit,
		tree
	},
	data() {
		return {
			searchParams: {},
			isShowMoreSearch: false,
			listLoading: false,
			listData: [],
			selected: [],
			page: new this.$constant.pageObj(),

			options: [],
            option:'',
			dialogVisible: false,
			tableData:[],

			echart: null,
            echartData: {},

			scoreAll: 0,// 总得分
			scorate: 0,//正确率
			unScora: 0,//错误率

			userInfo: {},
			permissionList: [],
			subData: [],
		};
	},
	methods: {
		comfirmSub() {
			this.searchParams.sbname = this.subData.name;
			this.searchParams.sbid = this.subData.id;
			this.searchParams.sid = this.userInfo.id;
			this.list();
			this.dialogVisible = false;
		},
		treeClick(data) {
			this.subData = data;
		},
		//获取科目
        selectSub() {
			if (this.permissionList == [] || this.permissionList.length == 0) {
				subApi.list({}, (response) => {
					this.permissionList = response.data;
				});
			}
			this.dialogVisible = true;
		},
		//获取答题数据
		list() {
			this.listLoading = true;
			this.searchParams.sid = this.userInfo.id;
			let params = this.$utils.merger(this.searchParams, this.page);
			api.list(params, response => {
				let val = response.data;
				console.log(val);
				this.judgeType(val);
				this.listLoading = false;
			})
		},
		//判断题型
		judgeType(val){
			for(let i=0;i<val.records.length;i++){
				if(val.records[i].type == 1){
					val.records[i].type = "单选题"
				}else if(val.records[i].type == 2){
					val.records[i].type = "多选题"
				}else if(val.records[i].type == 3){
					val.records[i].type = "判断题"
				}else if(val.records[i].type == 4){
					val.records[i].type = "填空题"
				}else if(val.records[i].type == 5){
					val.records[i].type = "简答题"
				}else if(val.records[i].type == 6){
					val.records[i].type = "论述题"
				}else if(val.records[i].type == 7){
					val.records[i].type = "编程题"
				}
			}
			this.listData = val;
		},
		//清空搜索框
		clearSearchVal() {
			this.searchParams = {};
			this.list();
		},
		//改变选择项
		selectionChange(val) {
			//清空
			this.selected = [];
			for (let item of val) {
				this.selected.push(item.id);
			}
		},
		//去详情
		toDetail(index, row) {
			this.$refs.edit.open(row, '详情');
		},
		//改变每页显示数量
		sizeChange(val) {
			this.page.size = val;
			this.list();
		},
		//改变现在的页码
		currentChange(val) {
			this.page.current = val;
			this.list();
		},
	},
	mounted() {
		this.userInfo = this.$caches.user.get();
		this.list();
	}
};
</script>

<style lang="scss" scoped="scoped">
	@import '~common/custom/css/common.scss';
</style>

